import React from 'react'
import { ChakraProvider, Box } from '@chakra-ui/react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { PostHogProvider } from '@/contexts/PostHogContext'
import { LanguageProvider } from '@/contexts/LanguageContext'
import { AnalyticsTracker } from '@/components/AnalyticsTracker'
import ProtectedApp from '@/components/ProtectedApp'
import LoginPage from '@/pages/LoginPage'
import LoginDesktopPage from '@/pages/LoginDesktopPage'
import ForgotPasswordPage from '@/pages/ForgotPasswordPage'
import ResetPasswordPage from '@/pages/ResetPasswordPage'
import AcceptInvitationPage from '@/pages/AcceptInvitationPage'
import LandingPage from '@/landing/LandingPage'
import ElectronTitlebar from '@/components/ElectronTitlebar'
import { useElectron } from '@/hooks/useElectron'
import theme from '@/theme'
import '@/i18n' // Initialize i18n

function AppRoutes() {
  const { isElectron } = useElectron()

  const searchParams = new URLSearchParams(window.location.search)
  const showDesktopLogin = searchParams.get('page') === 'new'

  let LoginComponent = LoginPage
  // Choose the appropriate login component based on environment
  if (showDesktopLogin || isElectron) {
    LoginComponent = LoginDesktopPage
  }

  return (
    <Routes>
      <Route path="/landing" element={<LandingPage />} />
      <Route path="/login" element={<LoginComponent />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/invitations/:token" element={<AcceptInvitationPage />} />
      <Route path="/*" element={<ProtectedApp />} />
    </Routes>
  )
}

function App() {
  return (
    <ChakraProvider theme={theme}>
      <PostHogProvider>
        <AuthProvider>
          <LanguageProvider>
            <Router>
              <AnalyticsTracker />
              <ElectronTitlebar />
              <Box minH="100vh" bg="gray.50">
                <AppRoutes />
              </Box>
            </Router>
          </LanguageProvider>
        </AuthProvider>
      </PostHogProvider>
    </ChakraProvider>
  )
}

export default App
